/** @format */

import * as Sentry from '@sentry/react'

import {logPageTransition} from './PageTransition'

const amplitude = window.amplitude

export function initSentry() {
  Sentry.init({
    dsn: window.formspree.SENTRY_DSN_REACT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
    tracesSampleRate: window.formspree.SENTRY_SAMPLE_RATE_REACT,
    replaysOnErrorSampleRate: window.formspree.SENTRY_REPLAY_ERROR_RATE_REACT,
    replaysSessionSampleRate: window.formspree.SENTRY_REPLAY_SAMPLE_RATE_REACT,
  })
}

export function initAmplitude() {
  const ampInst = amplitude && amplitude.getInstance()
  if (ampInst) {
    ampInst.init(window.formspree.AMPLITUDE_KEY, null, {
      // Configuration options. Do not change without consulting legal.
      includeReferrer: true,
      includeUtm: true,
      saveParamsReferrerOncePerSession: false,
      trackingOptions: {
        carrier: true,
        city: false,
        country: true,
        device_model: true,
        dma: false,
        ip_address: false,
        language: true,
        os_name: true,
        os_version: true,
        platform: true,
        region: false,
        version_name: true,
      },
    })
    logPageTransition(window.location.pathname)
  }
}
